<template>
  <div class="admin">
    <div id="nav">
      <router-link to="/admin/customers">Customers</router-link> |
      <router-link to="/admin/personnel">Personnel Details</router-link> |
      <router-link to="/admin/vehicles">Vehicle Details</router-link> |
      <router-link to="/admin/users">User Details</router-link> |
      <router-link to="/admin/inventory">Inventory</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminHeader",
  components: {},
};
</script>
